import { useContext } from "react";

import { useTranslator } from "@eo-locale/react";
import {
  FiCrop,
  FiRotateCcw,
  FiRotateCw,
  FiZoomIn,
  FiZoomOut
} from "react-icons/fi";

import { ButtonGroup } from "../../button/button";
import { IconButton } from "../../button/icon-button";

import { CropperContext, CropperContextType } from "../context";

function Controls() {
  const { translate } = useTranslator();
  const { cropperRef, status, isCropActive, setIsCropActive } = useContext(
    CropperContext
  ) as CropperContextType;

  const startCrop = () => cropperRef.current?.cropper.crop();
  const clearCrop = () => cropperRef.current?.cropper.clear();

  return (
    <ButtonGroup
      size="lg"
      width="full"
      display="flex"
      variant="tertiary"
      justifyContent="space-between"
      disabled={status === "disabled"}
    >
      <IconButton
        round
        icon={<FiCrop />}
        aria-pressed={isCropActive}
        aria-label={translate("common.crop")}
        onClick={() => {
          if (isCropActive) clearCrop();
          else startCrop();

          setIsCropActive(!isCropActive);
        }}
      />
      <IconButton
        round
        icon={<FiZoomIn />}
        aria-label={translate("common.zoomIn")}
        onClick={() => cropperRef.current?.cropper.zoom(0.1)}
      />
      <IconButton
        round
        icon={<FiZoomOut />}
        aria-label={translate("common.zoomOut")}
        onClick={() => cropperRef.current?.cropper.zoom(-0.1)}
      />
      <IconButton
        round
        icon={<FiRotateCcw />}
        aria-label={translate("common.rotateLeft")}
        onClick={() => cropperRef.current?.cropper.rotate(-90)}
      />
      <IconButton
        round
        icon={<FiRotateCw />}
        aria-label={translate("common.rotateRight")}
        onClick={() => cropperRef.current?.cropper.rotate(90)}
      />
    </ButtonGroup>
  );
}

export { Controls };
